module.exports = __webpack_public_path__ + "img/recording-03.bf55867f.svg";